import React, { lazy, Suspense, useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const SelectOrderType = lazy(() => import("./SelectOrderType"));
const ItemList = lazy(() => import("./ItemList"));
const SelectLocation = lazy(() => import("./SelectLocation"));
const AddEditItem = lazy(() => import("./AddEditItem"));
const OrderPlaced = lazy(() => import("./OrderPlaced"));
const CartBase = lazy(() => import("./Components/CartBase"));
const PaymentDetails = lazy(() => import("./PaymentDetails"));
const AppBar = lazy(() => import("./Components/SidenavAppbar"));
const OrderReceipt = lazy(() => import("./OrderReceipt"));
const CartDetails = lazy(() => import("./CartDetails"));
const InactivePlan = lazy(() => import("./InactivePlan"));
const SelectVendor = lazy(() => import("./SelectVendor"));
const NoMenu = lazy(()=> import ("./NoMenu"));
const PropertyClosed = lazy(()=> import ("./PropertyClosed"))
const renderLoader = () => (
  <Backdrop sx={{ zIndex: 9999 }} open={true}>
    <CircularProgress color="primary" />
  </Backdrop>
);

// PCI SAQ A: nginx sends the strict payment CSP only on a document loaded at /payment/*, and gtag
// is skipped only there. Reaching it by in-app navigation would keep the menu page's document, so
// reload once to get a fresh payment document (after the place-order dispatches have rendered).
const LOADED_ON_PAYMENT = window.location.pathname.startsWith("/payment/");
const PaymentPage = () => {
  useEffect(() => {
    if (!LOADED_ON_PAYMENT) window.location.reload();
  }, []);
  return LOADED_ON_PAYMENT ? <PaymentDetails /> : renderLoader();
};

const ApplicationRoutes = [
  {
    path: "/menu",
    element: (
      <Suspense fallback={renderLoader()}>
        <AppBar />
      </Suspense>
    ),
    children: [
      {
        path: "",
        element: (
          <Suspense fallback={renderLoader()}>
            <ItemList />
          </Suspense>
        ),
      },
      {
        path: "addItem",
        element: (
          <Suspense fallback={renderLoader()}>
            <AddEditItem />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/cart",
    element: (
      <Suspense fallback={renderLoader()}>
        <CartBase />
      </Suspense>
    ),
    children: [
      {
        path: "",
        element: (
          <Suspense fallback={renderLoader()}>
            <CartDetails />
          </Suspense>
        ),
      },
      {
        path: "updateItem",
        element: (
          <Suspense fallback={renderLoader()}>
            <AddEditItem />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/payment/:orderId",
    element: (
      <Suspense fallback={renderLoader()}>
        <PaymentPage />
      </Suspense>
    ),
  },
  {
    path: "/location",
    element: (
      <Suspense fallback={renderLoader()}>
        <SelectLocation />
      </Suspense>
    ),
  },
  {
    path: "/property/:property_id",
    element: (
      <Suspense fallback={renderLoader()}>
        <SelectOrderType />
      </Suspense>
    ),
  },
  {
    path: "/property/:property_id/ordertype/:order_type/",
    element: (
      <Suspense fallback={renderLoader()}>
        <SelectOrderType />
      </Suspense>
    ),
  },
  {
    path: "/property/:property_id/ordersource/:order_type/",
    element: (
      <Suspense fallback={renderLoader()}>
        <SelectOrderType />
      </Suspense>
    ),
  },


  {
    path: "/vendors/:property_id/",
    element: (
      <Suspense fallback={renderLoader()}>
        <SelectVendor />
      </Suspense>
    ),
  },
  {
    path: "/order_placed/:orderId/",
    element: (
      <Suspense fallback={renderLoader()}>
        <OrderPlaced />
      </Suspense>
    ),
  },
  {
    path: "/receipt/:orderId/:languageCode?",
    element: (
      <Suspense fallback={renderLoader()}>
        <OrderReceipt />
      </Suspense>
    ),
  },
  {
    path: "/inactive-plan/",
    element: (
      <Suspense fallback={renderLoader()}>
        <InactivePlan />
      </Suspense>
    ),
  },
  {
    path: "/no-menu/",
    element: (
      <Suspense fallback={renderLoader()}>
        <NoMenu />
      </Suspense>
    ),
  },
  {
    path: "/property-closed/:property_id",
    element: (
      <Suspense fallback={renderLoader()}>
        <PropertyClosed />
      </Suspense>
    ),
  },
];

export default ApplicationRoutes;
